<template>
    <div>
        <div class="row" v-if="['CATEGORY'].includes(tmpProduct.step)">
            <div class="col-12">
                <b-form-group id="input-group-1" label-for="input-1" class="mb-3 w-100">
                    <b-form-input
                        id="input-1"
                        type="text"
                        v-model="searchProduct"
                        placeholder="ค้นหาสินค้า"
                        class="s-product search-pos"
                    ></b-form-input>
                    <b-input-group-append class="search-pos s-icon">
                        <i class="fas fa-search"></i>
                    </b-input-group-append>
                </b-form-group>
            </div>
        </div>
        <b-card-text class="p-0 scroll-bar-pop card-tab">
            <div class="row pr-3 py-2">
                <div class="col-6 col-lg-8 col-xl-10">
                    <h3 v-html="stepTitle" class="cursor-pointer d-flex align-items-center" @click="checkStep()"></h3>
                </div>
                <div class="col-6 col-lg-4 col-xl-2 text-right" v-if="this.$USER_LOGIN.get().isAdmin">
                    <router-link :to="`/product`">
                        <b-button variant="primary" size="sm" :class="showCart !== 'non-slide' ? 'mr-4' : ''">
                            <i class="fas fa-plus"></i>
                            เพิ่มสินค้า
                        </b-button>
                    </router-link>
                </div>
            </div>
            <div class="row pr-3" v-if="['FIRST'].includes(tmpProduct.step)">
                <template v-for="category in categoryItem">
                    <div class="col-12 col-lg-6 col-xl-3 mb-3" :key="category.code">
                        <CardProduct
                            :product="{
                                title: category.name,
                                image: category.image,
                                type: category.type
                            }"
                            :class="{disabled:idOrder}"
                            @click.native="selectCategoryItem(category)"
                        />
                    </div>
                </template>
            </div>
            <template v-if="['CATEGORY'].includes(tmpProduct.step)">
                <draggable
                    v-bind="dragOptions"
                    v-model="products"
                    class="row pr-3" 
                    v-if="this.$USER_LOGIN.get().isAdmin"
                >
                    <div 
                        class="col-xl-3 col-md-6 col-lg-6 mb-3"
                        v-for="product in productFilter"
                        :key="product.id"
                    >
                        <CardItems
                            v-on:add-to-cart="addToCart(product)"
                            :class="{disabled:idOrder}"
                            :product="product"
                        />
                    </div> 
                </draggable>
                <div class="row" v-else>
                    <div
                        class="col-xl-3 col-md-6 col-lg-6 mb-3"
                        v-for="product in productFilter"
                        :key="product.id"
                    >
                        <CardItems
                            v-on:add-to-cart="addToCart(product)"
                            :class="{disabled:idOrder}"
                            :product="product"
                        />
                    </div>
                </div> 
                <button v-if="this.$USER_LOGIN.get().isAdmin" class="btn btn-warning btn-block btn-icon py-3" @click="moveProduct()">
                    บันทึกตำแหน่ง
                </button>
            </template>
        </b-card-text>
    </div>
</template>

<script>
import draggable from "vuedraggable";
import CardItems from "@/components/CardItem";
import { showSuccessModal } from "@/components/modalNotification.js";
import validatePop from "@/plugins/validatePop.js";
import categoryItem from '@/plugins/categoryItem.js'
import CardProduct from "@/components/CardProduct";
import { getListCategoryService , getListCategoryDetails } from "@/axios/service.js";

export default {
    props:{
        showCart: String,
        cart: Array,
        idOrder: [String, Number],
        addToCart: Function,
        busy: Boolean
    },
    components:{
        CardItems,
        CardProduct,
        draggable
    },
    data(){
        return{
            products: [],
            searchProduct: "",
            categoryItem: categoryItem,
            totalItem: {},
            tmpProduct:{
                step:"FIRST",
                categoryCode:"",
                categoryName:""
            }  
        }
    },
    mounted(){
        this.getApiCategoryItem()
    },
    methods:{
        getApiCategoryItem(){
            getListCategoryService( {page: 1 , perPage: 1000}, {type: 'item'} ).then( res => {
                res.item.forEach( item => {
                    item.code = `CODE_${item.id}`
                })
                this.categoryItem = [ ...this.categoryItem , ...res.item ];
                this.getApiItemDetail()
            })
        },
        getApiItemDetail(){
            let checkItemDetails = []
            this.categoryItem.forEach( category => {
                return checkItemDetails.push(
                    getListCategoryDetails( { categoryId: ((category.type == 'ITEM') ? category.id : 0) } )
                )
            })

            Promise.all(checkItemDetails).then( resData => {
                resData.forEach( (res, index) => {
                    if( res.item.length > 0 ){
                        this.totalItem[`CODE_${res.item[0].product_category_id}`] = res.item
                    }else{
                        this.totalItem[this.categoryItem[index].code] = res.item
                    }
                })
            })
        },
        selectCategoryItem( category ){
            this.tmpProduct.categoryCode = category.code
            this.tmpProduct.categoryName = category.name
            this.products = ( this.totalItem[this.tmpProduct.categoryCode].length > 0 ) 
                            ? this.totalItem[this.tmpProduct.categoryCode].sort((a, b) => {
                                return a.pointer_item - b.pointer_item;
                            }) : this.totalItem[this.tmpProduct.categoryCode];
            this.nextStep('CATEGORY')
        },
        checkStep(){
            if( this.tmpProduct.step == 'CATEGORY' ){
                this.nextStep('FIRST')
                this.tmpProduct.categoryCode = ''
                this.tmpProduct.categoryName = ''
            }
        },
        nextStep( nameStep ){
            this.tmpProduct.step = nameStep
        },
        moveProduct(){
            this.$emit('update:busy', true)
            this.productFilter.map((data , index)=>{
                data.pointer_item = index + 1
            })
            const itemProduct = {};
            this.productFilter.forEach(item => {
                itemProduct[item.id] = {pointer_item:item.pointer_item};
            });

            this.$http
                .put(
                    this.$API_URL + "/shop/product/pointer",
                    {
                        pointer_item: itemProduct,
                    },
                    {
                        headers: { Token: localStorage.getItem("access_token") }
                    }
                )
                .then(res => {
                let checkError = validatePop(res);
                    if (!checkError.status) {
                        this.$emit('update:busy', false)
                        this.showErrorModal(checkError.msg);
                        return false;
                    }
                    this.$emit('update:busy', false)
                    showSuccessModal("บันทึกข้อมูลสำเร็จ");
                })
                .catch(() => {
                
                });
        },
    },
    computed:{
        stepTitle(){
            let text = '';

            if( this.tmpProduct.step == 'FIRST' ){
                text = 'สินค้า'
            }else if( this.tmpProduct.step == 'CATEGORY' ){
                text = '<i class="fas fa-angle-left pr-1"></i> เลือกสินค้า'
            }

            if( this.$THEME.name == 'shippop' ){
                return text + `<small class="px-2"><a  href="https://docs.google.com/presentation/d/19KURIxwas0rWngr7_NTk_KXs90TTzyeCAMHFHZZ1r8M/edit?usp=sharing" target="_blank"> คู่มือการใช้งานสินค้า</a></small>`
            }

            return text
        },
        productFilter(){
            return this.products.filter(item => {
                return item.name
                .toLowerCase()
                .includes(this.searchProduct.toLowerCase());
            });  
        },
        dragOptions() {
            return {
                animation: 0,
                group: "description",
                disabled: false,
                ghostClass: "ghost"
            };
        }
    }
}
</script>